import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import { SearchField } from "../../../../SearchField/index.js";
import { Dropdown, DropdownContent, DropdownFilterButton, DropdownTextList } from "../../../Dropdown/index.js";
import i18n from "../../i18n/index.js";
import { OPTIONS } from "./constants.js";
const FilterHeader = ({ onSearch, setFocusEvent, sortItems })=>{
    const { languageCode } = useTranslation();
    const t = i18n[languageCode];
    const orderList = OPTIONS.map((item)=>({
            ...item,
            label: t[item.label]
        }));
    const handleSearch = (event)=>{
        const { value } = event.target;
        onSearch(value);
    };
    const onFocus = ()=>{
        setFocusEvent(true);
    };
    const intlCategories = orderList.map((itemSelect)=>({
            label: itemSelect.label,
            value: itemSelect.value
        }));
    const handleSort = (sortValue)=>{
        sortItems(String(sortValue));
    };
    const clearSearch = ()=>{
        onSearch('');
    };
    const handleClearOrder = ()=>{
        sortItems('');
    };
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-w-full tw-justify-between tw-items-center tw-mt-1.6",
        children: [
            /*#__PURE__*/ jsx(SearchField, {
                label: '',
                placeholder: t.ATTRIBUTES_PLACEHOLDER_SEARCH,
                onChange: handleSearch,
                onFocus: onFocus,
                onClearButtonClick: clearSearch
            }),
            /*#__PURE__*/ jsx("div", {
                className: "tw-relative",
                children: /*#__PURE__*/ jsxs(Dropdown, {
                    children: [
                        /*#__PURE__*/ jsx(DropdownFilterButton, {
                            disabled: false,
                            multiselect: false,
                            onClear: handleClearOrder,
                            children: t.DASHBOARD_USERS_FILTER_ORDER
                        }),
                        /*#__PURE__*/ jsx(DropdownContent, {
                            children: /*#__PURE__*/ jsx(DropdownTextList, {
                                items: intlCategories,
                                multiselect: false,
                                onSelect: handleSort
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export { FilterHeader };
